import { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import { useTooltipActions } from '../../core/components/overlay-tooltip/useTooltipActions.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';
import { getSlicesMap } from '../utils/get-slices-map.js';
import { getSlicesWithRelativeValues } from '../utils/plot-data.utils.js';
import { useSetHighlightedIdState } from './store/use-set-highlighted-ids-state.js';
import { useSetVisibleSlicesState } from './store/use-set-visible-slices-state.js';

/**
 * Hook that generates the corresponding handlers to interact with the Pie
 * @param data - array of the pie slices
 * @returns Handlers to interact with the Pie slices
 */
export function usePieHandlers(data: InternalSliceData[]) {
  const setVisibleSlicesState = useSetVisibleSlicesState();
  const setHighlightedIdState = useSetHighlightedIdState();
  const { reset } = useTooltipActions();

  const slicesMap = getSlicesMap(data);

  const onLegendItemHover = (hoveredSeries?: LegendItem) => {
    setHighlightedIdState(hoveredSeries?.id);
  };

  const onLegendItemClicked = (visibleSlices: LegendItem[]) => {
    reset();

    const newVisibleSlices: InternalSliceData[] = visibleSlices.map(
      (legendItem) => ({
        ...(slicesMap.get(legendItem.id) as InternalSliceData),
      }),
    );

    setVisibleSlicesState(
      getSlicesWithRelativeValues(newVisibleSlices) as InternalSliceData[],
    );
  };

  return { onLegendItemHover, onLegendItemClicked };
}
